module.exports = __webpack_public_path__ + "img/choosing-s1.469f2d5a.png";